/* <face-scan-shop-message> — Hinweis fuer Kunden, die aus der Shop-App kommen
   (SHYFT gibt es nicht in festen Groessen, der Gesichtsscan ersetzt sie).

   Stammt aus main (974aab8) und stand dort als {% javascript %} im Snippet.
   Hier als ES-Modul nach architektur.md §5: {% javascript %} landete in
   compiled_assets/snippet-scripts.js auf JEDER Seite, das Modul laedt nur,
   wo snippets/face-scan-shop-message.liquid rendert.

   JS ist hier noetig: Liquid kennt weder document.referrer noch die
   Query-Parameter der Anfrage. Das Element steht mit `hidden` im Markup und
   wird nur fuer Shop-App-Besucher sichtbar — ohne JS bleibt es verborgen,
   wie im Original. */

class FaceScanShopMessage extends HTMLElement {
  connectedCallback() {
    let referrer = null;
    try {
      referrer = document.referrer ? new URL(document.referrer) : null;
    } catch (fehler) {
      referrer = null;
    }
    const quelle = new URLSearchParams(location.search).get("utm_source");
    const ausShopApp =
      (referrer && (referrer.hostname === "shop.app" || referrer.hostname === "shop.com")) ||
      quelle === "shop-website";
    if (ausShopApp) this.hidden = false;
  }
}

if (!customElements.get("face-scan-shop-message")) {
  customElements.define("face-scan-shop-message", FaceScanShopMessage);
}
